import React from 'react'
import { formatCurrency } from '../../utils/api'

function MetricCard({ value, label, color = '', isCurrency = false }) {
  const displayValue = isCurrency ? formatCurrency(value) : value?.toLocaleString?.() || value

  return (
    <div className="metric-card">
      <div className={`metric-value ${color}`}>{displayValue}</div>
      <div className="metric-label">{label}</div>
    </div>
  )
}

function MetricsRow({ metrics }) {
  return (
    <div className="metrics-row">
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          value={metric.value}
          label={metric.label}
          color={metric.color}
          isCurrency={metric.isCurrency || metric.format === 'currency'}
        />
      ))}
    </div>
  )
}

export { MetricCard }
export default MetricsRow
